import { defineMessages } from 'react-intl';

const messages = defineMessages({
  conditionalDataBlockTitle: {
    id: 'Conditional data block',
    defaultMessage: 'Conditional data block',
  },
  titleLabel: {
    id: 'titleLabel',
    defaultMessage: 'Title',
  },
  defaultFieldsetTitle: {
    id: 'defaultFieldsetTitle',
    defaultMessage: 'Default',
  },
  titleDescription: {
    id: 'titleDescription',
    defaultMessage: 'Section friendly name',
  },
  columnValueLabel: {
    id: 'columnValueLabel',
    defaultMessage: 'Column value',
  },
  operatorLabel: {
    id: 'operatorLabel',
    defaultMessage: 'Operator',
  },
  existsOperator: {
    id: 'existsOperator',
    defaultMessage: 'Exists',
  },
  equalOperator: {
    id: 'equalOperator',
    defaultMessage: 'Equal',
  },
  notEqualOperator: {
    id: 'notEqualOperator',
    defaultMessage: 'Not equal',
  },
  includesOperator: {
    id: 'includesOperator',
    defaultMessage: 'Includes',
  },
  notIncludesOperator: {
    id: 'notIncludesOperator',
    defaultMessage: 'Not includes',
  },
  greaterThanOperator: {
    id: 'greaterThanOperator',
    defaultMessage: 'Greater than',
  },
  lessThanOperator: {
    id: 'lessThanOperator',
    defaultMessage: 'Less than',
  },
  conditionValueLabel: {
    id: 'conditionValueLabel',
    defaultMessage: 'Condition value',
  },
  countryFlagTitle: {
    id: 'Country Flag',
    defaultMessage: 'Country Flag',
  },
  settingsFieldsetTitle: {
    id: 'settingsFieldsetTitle',
    defaultMessage: 'Settings',
  },
  dropdownItemsFieldsetTitle: {
    id: 'dropdownItemsFieldsetTitle',
    defaultMessage: 'Dropdown items',
  },
  countryNameTitle: {
    id: 'countryNameTitle',
    defaultMessage: 'Country name',
  },
  countryNameDescription: {
    id: 'countryNameDescription',
    defaultMessage: 'Select the country to be displayed.',
  },
  htmlTagTitle: {
    id: 'htmlTagTitle',
    defaultMessage: 'HTML tag',
  },
  showNameTitle: {
    id: 'showNameTitle',
    defaultMessage: 'Show country name',
  },
  showNameDescription: {
    id: 'showNameDescription',
    defaultMessage:
      'Enable it to display the name of the selected country. Disable it to display the title of the page.',
  },
  showFlagTitle: {
    id: 'showFlagTitle',
    defaultMessage: 'Show country flag',
  },
  showFlagDescription: {
    id: 'showFlagDescription',
    defaultMessage:
      'Enable it to display the flag of the selected country. Disable it to display the preview image of the current page. If the page has no preview image set, it will display nothing.',
  },
  showDropdownTitle: {
    id: 'showDropdownTitle',
    defaultMessage: 'Show dropdown',
  },
  showDropdownDescription: {
    id: 'showDropdownDescription',
    defaultMessage:
      'Enable the dropdown select to navigate to other pages. In the "Dropdown items" section you can set the criterias to filter the items displayed in the dropdown. If no criterias are set, the siblings of the current page are displayed in the dropdown.',
  },
  querystringTitle: {
    id: 'querystringTitle',
    defaultMessage: 'Criteria',
  },
  source: {
    id: 'sourceField',
    defaultMessage: 'Source',
  },
  sourceLink: {
    id: 'sourceLinkField',
    defaultMessage: 'Link',
  },
  customConnectedBlock: {
    id: 'Custom connected block',
    defaultMessage: 'Custom connected block',
  },
  editCustomBlockTitle: {
    id: 'editCustomBlockTitle',
    defaultMessage: 'Edit custom connected block',
  },
  allowedParams: {
    id: 'allowedParamsField',
    defaultMessage: 'Allowed params',
  },
  placeholder: {
    id: 'placeholderField',
    defaultMessage: 'Placeholder',
  },
  blockType: {
    id: 'blockTypeField',
    defaultMessage: 'Select block type',
  },
  sources: {
    id: 'sourcesField',
    defaultMessage: 'Sources',
  },
  iframeTitle: {
    id: 'iframeTitle',
    defaultMessage: 'Data-connected embed',
  },
  embedUrl: {
    id: 'embedUrl',
    defaultMessage: 'Embed URL',
  },
  height: {
    id: 'height',
    defaultMessage: 'Height',
  },
  heightDescription: {
    id: 'heightDescription',
    defaultMessage: 'Map height',
  },
  dataQueryFilter: {
    id: 'DataQuery Filter',
    defaultMessage: 'DataQuery Filter',
  },
  editDataQueryFilterTitle: {
    id: 'editDataQueryFilterTitle',
    defaultMessage: 'Edit DataQuery Filter',
  },
  placeholderValueTitle: {
    id: 'placeholderValueTitle',
    defaultMessage: 'Placeholder value',
  },
  dataProviderTitle: {
    id: 'dataProviderTitle',
    defaultMessage: 'Data provider',
  },
  alignmentTitle: {
    id: 'alignmentTitle',
    defaultMessage: 'Alignment',
  },
  autoqueryFieldTitle: {
    id: 'autoqueryFieldTitle',
    defaultMessage: 'Autoquery field',
  },
  dottedTableChartTitle: {
    id: 'Dotted Table Chart',
    defaultMessage: 'Dotted Table Chart',
  },
  dataSourceFieldsetTitle: {
    id: 'dataSourceFieldsetTitle',
    defaultMessage: 'Data source',
  },
  stylingFieldsetTitle: {
    id: 'stylingFieldsetTitle',
    defaultMessage: 'Styling',
  },
  descriptionTitle: {
    id: 'descriptionTitle',
    defaultMessage: 'Description',
  },
  maxDotCountTitle: {
    id: 'maxDotCountTitle',
    defaultMessage: 'Maximum dot count',
  },
  columnsTitle: {
    id: 'columnsTitle',
    defaultMessage: 'Columns',
  },
  rowsTitle: {
    id: 'rowsTitle',
    defaultMessage: 'Rows',
  },
  sizeDataTitle: {
    id: 'sizeDataTitle',
    defaultMessage: 'Size data',
  },
  colorsTitle: {
    id: 'colorsTitle',
    defaultMessage: 'Colors',
  },
  tooltipFormatSpecifierTitle: {
    id: 'tooltipFormatSpecifierTitle',
    defaultMessage: 'Tool-tip format specifier',
  },
  tooltipFormatSpecifierDescription: {
    id: 'tooltipFormatSpecifierDescription',
    defaultMessage: 'See D3 format documentation',
  },
  tooltipTextTemplateTitle: {
    id: 'tooltipTextTemplateTitle',
    defaultMessage: 'Tool-tip text template',
  },
  tooltipTextTemplateDescription: {
    id: 'tooltipTextTemplateDescription',
    defaultMessage:
      'Add suffix/prefix to text. Use {value} for value placeholder',
  },
  headerTitle: {
    id: 'headerTitle',
    defaultMessage: 'Header',
  },
  componentType: {
    id: 'componentType',
    defaultMessage: 'Component type',
  },
  newWindowChoice: {
    id: 'newWindowChoice',
    defaultMessage: 'New window',
  },
  sameWindowChoice: {
    id: 'sameWindowChoice',
    defaultMessage: 'Same window',
  },
  externalLink: {
    id: 'externalLink',
    defaultMessage: 'External link',
  },
  linkTemplate: {
    id: 'linkTemplate',
    defaultMessage: 'Link template',
  },
  formatSpecifier: {
    id: 'formatSpecifier',
    defaultMessage: 'Format specifier',
  },
  textTemplate: {
    id: 'textTemplate',
    defaultMessage: 'Text template',
  },
  dataColumn: {
    id: 'dataColumn',
    defaultMessage: 'Data column',
  },
  dataColumnLink: {
    id: 'dataColumnLink',
    defaultMessage: 'Data column link',
  },
  dataConnectedTable: {
    id: 'dataConnectedTable',
    defaultMessage: 'Data connected table',
  },
  dataQuery: {
    id: 'dataQuery',
    defaultMessage: 'Data query',
  },
  columnsDescription: {
    id: 'columnsDescription',
    defaultMessage: 'Leave empty to show all columns',
  },
  allowRichText: {
    id: 'allowRichText',
    defaultMessage: 'Allows rich text formatting',
  },
  allowedURLParams: {
    id: 'allowedURLParams',
    defaultMessage: 'Allowed URL parameters',
  },
  maxResults: {
    id: 'maxResults',
    defaultMessage: 'Maximum results',
  },
  noResults: {
    id: 'noResults',
    defaultMessage: 'No results',
  },
  templateTitle: {
    id: 'templateTitle',
    defaultMessage: 'Template',
  },
  paginationTitle: {
    id: 'paginationTitle',
    defaultMessage: 'Pagination',
  },
  showHeader: {
    id: 'showHeader',
    defaultMessage: 'Show header',
  },
  stripeRows: {
    id: 'stripeRows',
    defaultMessage: 'Stripe alternate rows with color',
  },
  removeTableBorder: {
    id: 'removeTableBorder',
    defaultMessage: 'Remove table border',
  },
  makeTableCompact: {
    id: 'makeTableCompact',
    defaultMessage: 'Make the table compact',
  },
  divideRow: {
    id: 'divideRow',
    defaultMessage: 'Divide each row into separate cells',
  },
  columnTitle: {
    id: 'columnTitle',
    defaultMessage: 'Column',
  },
  dataConnectedEmbed: {
    id: 'Data connected embed',
    defaultMessage: 'Data connected embed',
  },
  dataTable: {
    id: 'Data Table',
    defaultMessage: 'Data Table',
  },
});

export default messages;
